import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import InterestEditor from './InterestEditor';

function AddInterest() {
	const navigate = useNavigate();

	return (
		<EntityList>
			<Helmet>
				<title>Agregar Interes</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Intereses', to: '/AdminScreen/interests' },
					{ label: 'Agregar Interes' },
				]}
				title='Agregar Interes'
				subtitle='Completá los datos para registrar el interés.'
			/>
			<InterestEditor
				mode='create'
				onCancel={() => navigate('/AdminScreen/interests')}
				onSaved={() => navigate('/AdminScreen/interests')}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default AddInterest;
